import React, { useMemo, useState } from 'react';

// Backward-compatible CodeBlock.
// If `tabs` is provided, render tabbed code with a Copy Full Request button.
// Otherwise, render a simple code block with Copy.
const CodeBlock = ({ code, language = 'bash', tabs }) => {
  const [copied, setCopied] = useState(false);
  const [activeTab, setActiveTab] = useState(tabs && Object.keys(tabs)[0]);

  const activeCode = useMemo(() => {
    if (!tabs) return code;
    return tabs[activeTab] || '';
  }, [tabs, activeTab, code]);

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  // For tabbed mode, copy the currently active tab content.
  const copyTarget = tabs ? activeCode : code;

  return (
    <div className="code-block-wrapper">
      {tabs && (
        <div className="flex items-center justify-between px-2 py-1 bg-gray-800 rounded-t-md border border-gray-700 border-b-0">
          <div className="flex items-center gap-2">
            {Object.keys(tabs).map((tabKey) => (
              <button
                key={tabKey}
                onClick={() => setActiveTab(tabKey)}
                className={`px-2 py-1 text-xs rounded ${activeTab === tabKey ? 'bg-gray-700 text-white' : 'text-gray-300 hover:text-white'}`}
              >
                {tabKey}
              </button>
            ))}
          </div>
          <button
            className={`text-xs text-gray-300 hover:text-white`}
            onClick={() => handleCopy(copyTarget)}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      )}
      <pre className={`bg-[#3A3E46] p-4 ${tabs ? 'rounded-b-lg border-t-0' : 'rounded-lg'} overflow-x-auto border border-[#3A3E46]`}>
        <code>{copyTarget}</code>
      </pre>
      {!tabs && (
        <button
          className={`copy-button ${copied ? 'copied' : ''}`}
          onClick={() => handleCopy(copyTarget)}
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      )}
    </div>
  );
};

export default CodeBlock;
